import {useEffect} from 'react';

import {useSelector} from 'react-redux';

import {
  changePageFavicon,
  changePageTitle,
  ORIGINAL_FAVICON_PATH,
  ORIGINAL_PAGE_TITLE,
} from 'app/utils/pageHead';

const NOW = new Date().getTime();

function getUnreadFavicon(): string | null {
  if (ORIGINAL_FAVICON_PATH == null) {
    return null;
  }
  const pathParts: string[] = ORIGINAL_FAVICON_PATH.split('/');
  const filenameParts = (pathParts.pop() || '').split('.');
  const path = pathParts.join('/');

  const ext = filenameParts.pop();
  const filename = filenameParts.join('.');
  return `${path}/${filename}-unread.${ext}`;
}

export function PageHeadNotificationsSyncer(): JSX.Element | null {
  const unreadFaviconPath = `${getUnreadFavicon()}?ts=${NOW}}`;
  const readFaviconPath = `${ORIGINAL_FAVICON_PATH}?ts=${NOW}`;

  const numNotifications = useSelector((state) =>
    state.notifications.get('numNotifications')
  );

  useEffect(() => {
    updateFavicon(numNotifications);
    updatePageTitle(numNotifications);
  }, [numNotifications]);

  function updateFavicon(numNotifications: number) {
    const favicon = numNotifications > 0 ? unreadFaviconPath : readFaviconPath;
    changePageFavicon(favicon);
  }

  function updatePageTitle(numNotifications) {
    const title =
      numNotifications > 0
        ? `(${numNotifications}) ${ORIGINAL_PAGE_TITLE}`
        : ORIGINAL_PAGE_TITLE;

    changePageTitle(title);
  }

  return null;
}
